import React, { useEffect, useState } from "react";
import { ScrollView, StyleSheet } from "react-native";
import { IconButton, useTheme } from "react-native-paper";
import { useTranslation } from "react-i18next";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { Block } from "app/shared/components/blocks/block";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { spacing } from "app/shared/styles/spacing";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import FormTermDepositDetails from "./form-term-deposit-detail/form-term-deposit-detail.web";
import DotContainer from "app/shared/components/dots";
import { StackActions, useNavigation } from "@react-navigation/core";
import { useDispatch, useSelector } from "react-redux";
import { ACCOUNT } from "app/shared/services/services-model.type";
import { Constant } from "app/shared/constant/constant";
import TermScroll from "./term-scroll/term-scroll";
import EmptyBox from "app/shared/components/empty-box/empty-box.web";
import { getListTermDepositPendingSelector, getListTermDepositSelector, getListTermStoreSelector } from "./reducer/selectors";
import { fetchTermDepositListRequest } from "./reducer/actions";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import Carousel, { ICarouselInstance } from "react-native-reanimated-carousel";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

const ListTermDeposit = () => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();
  const { dispatch } = useNavigation();
  const isDesktop = useDesktopMediaQuery();
  const r = React.useRef<ICarouselInstance>(null);
  const listTermStore = useSelector(getListTermStoreSelector);
  const listTermDepositStore = useSelector(getListTermDepositSelector);
  const pending = useSelector(getListTermDepositPendingSelector);
  const contactId = useSelector(getContactIdSelector);

  const [selectIndex, setSelectIndex] = useState(0);
  const [listTermDeposit, setListTermDeposit] = useState<ACCOUNT[]>([]);
  const [termDeposit, setTermDeposit] = useState<ACCOUNT>({});
  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("FUNC_TIET_KIEM"),
      onPressSubtitle: () => {
        dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
      },
    },
    {
      name: t("SAVING_DANH_SACH_SO_TIET_KIEM"),
      onPressSubtitle: () => {},
    },
  ];

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        scrollStyle: { flexGrow: 1 },
        cauroselStyle: {
          width: "100%",
          height: 148,
          justifyContent: "center",
          alignItems: "center",
        },
        displayIconBtn: {
          display: isDesktop ? "flex" : "none",
        },
      }),
    [isDesktop],
  );

  const eventPushCleverTap = (cta?: string,response?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(cta, response);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const handlerParamsCleverTap = (cta?: string, response?: string) => {
    console.log("handlerParamsCleverTap");
    //Nộp thêm | Tất toán | Trang chủ
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_list_deposit_status: response || "",
      ct_cta: cta || "",
    };

    return {
      eventNameCT: "ct_list_of_deposit",
      paramsCT: param,
    };
  };

  useEffect(() => {
    dispatchStore(fetchTermDepositListRequest());
  }, [dispatchStore]);

  useEffect(() => {
    const getListTermDeposit = (data?: ACCOUNT[]) => {
      let listTerm: ACCOUNT[] = [];
      if (data?.length) {
        listTerm = data.filter((acc) => {
          return Constant.ACCOUNTTYPE.ACCOUNT_TERM_DEPOSIT.includes(acc.ACCOUNTTYPE || "") && acc.CURRENTBALANCE !== "0";
        });
      }
      return { listTerm };
    };

    if (listTermDepositStore?.ACCOUNT.length) {
      const { listTerm } = getListTermDeposit(listTermDepositStore?.ACCOUNT);
      setListTermDeposit(listTerm);
    }
  }, [listTermDepositStore]);

  useEffect(() => {
    if (listTermDeposit.length && termDeposit.ACCOUNTNO !== listTermDeposit[selectIndex].ACCOUNTNO)
      setTermDeposit(listTermDeposit[selectIndex]);
  }, [listTermDeposit, selectIndex, termDeposit]);

  useEffect(() => {
    if (listTermStore.statusRq === "ok") {
      eventPushCleverTap("Danh sách", "success");
    } else if (listTermStore.statusRq === "error") {
      eventPushCleverTap("Danh sách", "failure " + listTermStore.errorMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listTermStore.statusRq]);

  const FormEmpty = listTermDeposit.length === 0 && !pending ? <EmptyBox subtitle={t("SAVING_KHONG_CO_SO_TIET_KIEM")} /> : null;

  const prevPage = React.useCallback(() => {
    r.current?.prev();
  }, []);

  const nextPage = React.useCallback(() => {
    r.current?.next();
  }, []);

  const FormCards = listTermDeposit.length > 0 && (
    <>
      <Carousel
        ref={r}
        style={styles.cauroselStyle}
        width={320}
        loop={false}
        onSnapToItem={(_index) => {
          setSelectIndex(_index);
        }}
        height={148}
        data={listTermDeposit}
        renderItem={({ item, animationValue }) => (
          <TermScroll
            onPressItem={() =>
              r.current?.scrollTo({
                count: animationValue.value,
                animated: true,
              })
            }
            item={item}
            animationValue={animationValue}
          />
        )}
      />

      <Block row middle center>
        <IconButton
          style={styles.displayIconBtn}
          icon="chevron-left"
          color={selectIndex === 0 ? colors.disabled : colors.accent}
          size={24}
          onPress={prevPage} hasTVPreferredFocus={undefined} tvParallaxProperties={undefined}        />
        <DotContainer sizeRatio={1} activeDotColor={colors.accent} curPage={selectIndex} maxPage={listTermDeposit.length} />
        <IconButton
          style={styles.displayIconBtn}
          icon="chevron-right"
          color={selectIndex === listTermDeposit.length - 1 ? colors.disabled : colors.accent}
          size={24}
          onPress={nextPage} hasTVPreferredFocus={undefined} tvParallaxProperties={undefined}        />
      </Block>
      <FormTermDepositDetails data={termDeposit} />
    </>
  );

  return (
    <Block flex={1}>
      <ScrollView contentContainerStyle={styles.scrollStyle}>
        <HeaderNav />
        <NavTitleBar title={t("SAVING_DANH_SACH_SO_TIET_KIEM")} subtitles={subtitlesArrays} />
        <Block flex={1} pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <>
            {FormEmpty}
            {FormCards}
          </>
        </Block>
      </ScrollView>
    </Block>
  );
};

export default ListTermDeposit;
